// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3WUV9","title":"_1wOvu","changes":"_2reNC","text":"OOm2_","old":"_2s1q4","new":"_1_bmX","arrow":"ERjx3"};